
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('branch_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link to="/branch/create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
        </div>
        <div class="x_body">
            <div class="card x_card no-bor">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i aria-hidden="true" class="fa fa-search"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                <th>{{ $t('name') }}</th>
                                <th>{{ $t('type') }}</th>
                                <th>{{ $t('phone') }}</th>
                                <th>{{ $t('address') }}</th>
                                <th style="width: 22px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{name: 'branch_edit', params:{ id:ret.Id }}">{{ret.Name}}</router-link></td>
                                <td>{{ret.TypeName}}</td>
                                <td>{{ret.Phone}}</td>
                                <td>{{ret.Address}}</td>
                                <td>
                                    <button type="button" class="btn btn-danger btn-table-xs btn-delete" @click="onDelete(ret)"><i class="fa fa-times" aria-hidden="true"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>     
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
export default {
    data: function(){
        return {
            query:{
                Text: '',
                Page: 1,
                Total: 0,
                Limit: 25
            },
            records:[]
        }
    },
    created: function(){
        this.toList();
    },
    methods: {
        toList: function(){
            var loading = this.$loading.show();
            this.$api().post('branch/list', this.query).then((res) => {
                if(this.$isValid(res)){
                    this.records = res.data.Data;
                    this.query.Total = res.data.Total;
                }
            }).finally(function(){ loading.hide(); });
        },
        onDelete: function(item){
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                if (result.value) {
                    this.$api().post('branch/delete', { Id: item.Id }).then(res => {
                        if(this.$isValid(res)){
                            this.toList();
                            Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
                        }
                    });
                }
            });
        }
    }
}
</script>